import React, { Fragment } from "react";
import Link from "next/link";
import bgimage from "../../assets/images/store_mobile.png";
import arrow from "../../assets/images/arrow2.png";
import Image from "next/image";
import styles from "@/styles/mobile_sencostory.module.scss";
import { homeLinks } from "@/data/home";
const Mobile_SencoStory = () => {
  return (
    <Fragment>
      <section>
        <div className={styles.sencostory}>
          <Image src={homeLinks.store.image} alt="" width={515} height={634} />
          <div className={styles.sencostory_main}>
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className={styles.h2}>{homeLinks.store.title}</div>
                  <Link href={homeLinks.store.link} passHref>
                    <div className={styles.btn_get_started}>LOCATE STORE</div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className={styles.history}>
            <div className={styles.h4}>The Senco Story</div>
            <div
              dangerouslySetInnerHTML={{
                __html: homeLinks.store.story,
              }}
            ></div>

            <Link href={homeLinks.store.story_link} passHref>
              Know More...
            </Link>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Mobile_SencoStory;
